import * as React from 'react';

// BEEM chevron-down — matches the custom Select dropdown arrow used app-wide
// (see the `.ant-select-arrow` rule in src/global.less).
export default (props) => (
  <svg
    width={props.width || '16'}
    height={props.height || '16'}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7 10l5 5 5-5"
      stroke={props.color || '#6C7280'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
